
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import NavBar from '@/components/NavBar/NavBar.vue';
  import ProfileHeader from '@/components/Profile/ProfileHeader.vue';
  import {authModule, userState} from '@/utils/store-acessor';

  @Component({
    components: {
      ProfileHeader,
      NavBar
    }
  })
  export default class ProfileIndexPage extends Vue {
    @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;

    async mounted() {
      if (this.isAuthenticated) {
        await userState.fetchUser();
      }
    }
  }
